<template>
  <div class="avatar-list">
    <ts-button type="primary" v-if="canAdd" size="small" circle filled @click="handleAddButtonClick">
      <ts-icon icon="plus" size="xx-small" color="#020203" title="Add" />
    </ts-button>
    <div v-for="user in users" :key="user.id" class="badge">
      {{ formatInitials(user.name) }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
.avatar-list {
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;

  > * {
    margin-left: -8px;
  }
}

.badge {
  width: 32px;
  height: 32px;
  border-radius: 32px;

  background: #ebecf0;
  background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
  background-blend-mode: soft-light, normal;
  background-clip: padding-box;
  border: 2px solid rgba(255, 255, 255, 0.32);
  box-shadow: -5px -5px 10px 0 rgba(250, 251, 255, 0.8), 5px 5px 10px 0 rgba(166, 171, 189, 0.48);

  font-family: Roboto;
  font-size: 12px;
  color: #6d7587;

  display: flex;
  justify-content: center;
  align-items: center;
  cursor: default;
}
</style>

<script>
export default {
  props: {
    canAdd: {
      type: Boolean,
      default: true
    },
    users: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    formatInitials(name) {
      return name
        .replace(/[^a-zA-Z0-9- ]/g, '')
        .match(/\b\w/g)
        .join('');
    },
    handleAddButtonClick() {
      this.$emit('click');
    }
  }
};
</script>
